import React, { useState, useEffect, useContext } from "react";
import "./NewEmiCalculator.css";
import {
  Select,
  MenuItem,
  Button,
  Card,
  CardContent,
  FormControl,
  OutlinedInput,
  InputAdornment,
  useMediaQuery,
  Popover,
  List,
  ListItem,
  ListItemText,
  ListItemIcon,
  Typography,
  ClickAwayListener,
  styled,
  Tooltip,
  tooltipClasses,
} from "@mui/material";
import { WhatsApp, Email, ShareOutlined } from "@mui/icons-material";
// import MetadataContext from "../../../Pages/MetadataContext";
import StepOne from "./Steps/StepOne";
import SideBar from "./SideBar/SideBar";
import MoreLikeThis from "./MoreLikeThis";
import { useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";

const NewEmiCalculator = () => {
  const [loanAmount, setLoanAmount] = useState(100000);
  const [interestRate, setInterestRate] = useState(10);
  const [loanTenure, setLoanTenure] = useState(20);
  const [newEMI, setNewEMI] = useState(null);
  const [monthlySavings, setMonthlySavings] = useState(null);
  const [totalSavings, setTotalSavings] = useState(null);
  const [existingEMI, setExistingEMI] = useState(null);
  const [anchorEl, setAnchorEl] = useState(null);
  const [openDiscloser, setOpenDiscloser] = useState(false);

  const isSmallScreen = useMediaQuery("(max-width:576px)");
  const navigate = useNavigate();

  const calculateEMI = (principal, rate, tenure) => {
    const monthlyRate = rate / (12 * 100);
    const months = tenure * 12;
    const emi =
      (principal * monthlyRate * Math.pow(1 + monthlyRate, months)) /
      (Math.pow(1 + monthlyRate, months) - 1);
    return isNaN(emi) || !isFinite(emi) ? 0 : emi.toFixed(2);
  };

  const formatter = (amount) => {
    return new Intl.NumberFormat("en-IN", {
      style: "currency",
      currency: "INR",
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    }).format(amount);
  };

  const handleCalculate = () => {
    const existingEMIValue = calculateEMI(
      loanAmount,
      parseFloat(interestRate) || 0,
      loanTenure
    );

    const newInterestRate = (parseFloat(interestRate) || 0) - 0.5;
    const newEMIValue = calculateEMI(loanAmount, newInterestRate, loanTenure);

    setExistingEMI(formatter(Math.round(existingEMIValue)));
    setNewEMI(formatter(Math.round(newEMIValue)));
    setMonthlySavings(formatter(Math.round(existingEMIValue - newEMIValue)));
    setTotalSavings(
      formatter(Math.round((existingEMIValue - newEMIValue) * loanTenure * 12))
    );
  };

  const handleShareClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const LightTooltip = styled(({ className, ...props }) => (
    <Tooltip {...props} classes={{ popper: className }} />
  ))(({ theme }) => ({
    [`& .${tooltipClasses.arrow}`]: {
      color: theme.palette.common.white,
    },
    [`& .${tooltipClasses.tooltip}`]: {
      backgroundColor: theme.palette.common.white,
      color: "rgba(0, 0, 0, 0.87)",
      boxShadow: theme.shadows[1],
      fontSize: 11,
    },
  }));

  const handeDiscloserTooltipClose = () => {
    setOpenDiscloser(false);
  };

  const handeDiscloserTooltipOpen = () => {
    setOpenDiscloser(true);
  };

  const open = Boolean(anchorEl);
  const id = open ? "share-popover" : undefined;

  const shareMessage = `Wow! I just saved ${monthlySavings} per month on my EMI! 🎉 That's a total saving of ${totalSavings}! Want to check how much you can save? Try this EMI Reduction Calculator now! 🚀💰\n\nCheck it out here!\nhttps://minemi.ai/calculators/emi-reduction-calculator`;

  const formatCurrency = (value) => {
    return value.toLocaleString("en-IN");
  };

  const handleAmountChange = (e, setter) => {
    const value = e.target.value.replace(/,/g, ""); // Remove commas
    if (/^\d*\.?\d*$/.test(value)) {
      const numericValue = Number(value); // Convert to number
      if (numericValue <= 100000000) {
        setter(numericValue);
      }
    }
  };

  const getWhatsAppShareMessage = () => {
    return encodeURIComponent(
      `Wow! I just saved ${monthlySavings} per month on my EMI! 🎉 That's a total saving of ${totalSavings}! Want to check how much you can save? Try this EMI Reduction Calculator now! 🚀💰\n\nCheck it out here!\nhttps://minemi.ai/calculators/emi-reduction-calculator`
    );
  };

  const handleWhatsAppShare = () => {
    const url = `https://wa.me/?text=${getWhatsAppShareMessage()}`;
    window.open(url, "_blank");
  };

  const advertiserData = (
    <div>
      <Typography>
        Minemi partners with trusted lenders, and we may receive compensation
        when you click on links or take action on their site. However, this does
        not affect our evaluations or ratings. Our opinions are our own.
      </Typography>
          
    </div>
  );

  // const { setMetadata } = useContext(MetadataContext);

  // useEffect(() => {
  //   setMetadata({
  //     pageTitle: "EMI Reduction Calculator | MinEmi",
  //     pageDescription:
  //       "Use MinEMI’s Repo Rate Based EMI Calculator to estimate your EMI changes instantly. Plan smarter for repo rate hikes or cuts across banks and loan types.",
  //     pageKeywords:
  //       "EMI Reduction Calculator, Loan EMI Calculator, Lower EMI, EMI Savings, Home Loan Calculator, Interest Rate Cut, Monthly EMI Calculator, MinEmi EMI Calculator, Loan Repayment, EMI Reduction Tool",
  //     canonicalUrl: "https://minemi.ai/calculators/emi-reduction-calculator",
  //   });
  // }, [setMetadata]);
  return (
    <div className="emi_repo_container " style={{ backgroundColor: "#f8f8f8" }}>
      <div className="bg-gradient-to-br from-[#59266d] to-[#311664] text-white p-10 px-6 sm:px-16  w-full mx-auto shadow-xl">
        <p className="pages_links bg-transparent links ">
          <Link
            to="/"
            underline="hover"
            className="bg-transparent archivo"
            style={{
              fontSize: isSmallScreen ? 13 : 16,
              color: "#ffffff",
              cursor: "pointer",
              fontFamily: "'Archivo', sans-serif",
            }}
          >
            Home
          </Link>
          &nbsp;
          <span
            className="d-none d-md-inline bg-transparent ps-1 px-1 "
            style={{
              color: "#ffffff",
              fontFamily: "'Archivo', sans-serif",
              fontWeight: 700,
            }}
          >
            &gt;
          </span>
          &nbsp;
          <Link
            to="/calculators"
            underline="hover"
            className="d-none d-md-inline bg-transparent archivo"
            style={{
              fontSize: isSmallScreen ? 13 : 16,
              color: "#ffffff",
              cursor: "pointer",
              fontFamily: "'Archivo', sans-serif",
            }}
          >
            Calculators
          </Link>
          &nbsp;
          <span
            className="d-none d-md-inline bg-transparent ps-1 px-1 "
            style={{
              color: "#ffffff",
              fontFamily: "'Archivo', sans-serif",
              fontWeight: 700,
            }}
          >
            &gt;
          </span>
          &nbsp;
          <Link
            underline="hover"
            className="d-none d-md-inline fw-bold bg-transparent archivo"
            style={{
              fontSize: isSmallScreen ? 13 : 16,
              color: "#ffffff",
              cursor: "pointer",
              fontFamily: "'Archivo', sans-serif",
            }}
          >
            EMI Reduction Calculator
          </Link>{" "}
        </p>

        {/* <div id="advertiser__discloser" className="mt-3 mt-lg-5">
          <ClickAwayListener onClickAway={handeDiscloserTooltipClose}>
            <div className="w-auto">
              <LightTooltip
                arrow
                open={openDiscloser}
                title={<div>{advertiserData}</div>}
              >
                <div>
                  <Link
                    underline="hover"
                    style={{
                      fontSize: 13,
                      color: "",
                      lineHeight: "20px",
                      fontFamily: "'Archivo', sans-serif",
                    }}
                    onClick={handeDiscloserTooltipOpen} // Only this triggers tooltip to open
                  >
                    Advertiser disclosure
                  </Link>
                </div>
              </LightTooltip>
            </div>
          </ClickAwayListener>
        </div> */}
        <div className="content_heading d-flex flex-column align-items-start mt-4 mt-md-5">
          <Typography
            className="bg-transparent archivo fw-bold"
            sx={{
              fontSize: {
                xs: "32px",
                sm: "35.4312px",
                md: "40.2752px",
                lg: "53.1927px",
              },
              lineHeight: {
                xs: "38px",
                sm: "42.0745px",
                md: "47.8268px",
                lg: "63.1663px",
              },
              letterSpacing: "0.04px",
              textAlign: "start",
              fontFamily: "'Archivo', sans-serif",
            }}
          >
            Repo Rate Based EMI Calculator
          </Typography>
          <Typography
            sx={{
              fontSize: 16,
              lineHeight: "24px",
              letterSpacing: "0.08px",
              fontFamily: "'Archivo',sans-serif",
            }}
            className="sub-heading bg-transparent my-2 archivo"
          >
            Estimate how changes in repo rate affect your EMI across all banks
            and loans.
          </Typography>
        </div>
      </div>
      <div className="emi_repo_contents_section d-flex flex-column justify-content-center align-items-center w-100">
        <Card
          variant="outlined"
          sx={{
            width: isSmallScreen ? "100%" : "500px",
            marginTop: 5,
            marginBottom: 5,
          }}
        >
          <CardContent>
            <h1
              style={{
                color: "#311664",
                fontSize: "25px",
                textAlign: "center",
                fontWeight: 700,
              }}
            >
              EMI Reduction Calculator
            </h1>
            <p align="center" style={{ color: "#592680", fontSize: "14px" }}>
              Estimate your new EMI based on a 0.5% repo rate cut
            </p>

            <div className=" p-2 pt-3">
              <p
                style={{ fontSize: "14px", fontWeight: 600, color: "#311664" }}
                className="mb-1"
              >
                Loan Amount (₹)
              </p>
              <FormControl fullWidth sx={{ marginBottom: "16px" }}>
                <OutlinedInput
                  id="outlined-adornment-emi"
                  fullWidth
                  size="small"
                  startAdornment={
                    <InputAdornment position="start">
                      <span className="archivo">₹</span>
                    </InputAdornment>
                  }
                  value={formatCurrency(loanAmount)} // Display value with commas
                  onChange={(e) => handleAmountChange(e, setLoanAmount)}
                />
              </FormControl>
            </div>

            <div className="p-2">
              <p
                style={{ fontSize: "14px", fontWeight: 600, color: "#311664" }}
                className="mb-1"
              >
                Current Interest Rate (%)
              </p>
              <FormControl fullWidth sx={{ marginBottom: "16px" }}>
                <OutlinedInput
                  id="outlined-adornment-amount"
                  fullWidth
                  size="small"
                  endAdornment={
                    <InputAdornment position="end">
                      <span className="archivo">%</span>
                    </InputAdornment>
                  }
                  value={interestRate || 0}
                  onChange={(e) => {
                    let value = e.target.value.replace(/,/g, ""); // Remove commas

                    if (/^\d*\.?\d*$/.test(value)) {
                      if (value === "") {
                        setInterestRate(""); // Allow empty field temporarily
                      } else {
                        setInterestRate(value.replace(/^0+/, "") || "0"); // Remove leading zero
                      }
                    }
                  }}
                  onFocus={() => interestRate === "0" && setInterestRate("")} // Empty field on focus
                  onBlur={() =>
                    setInterestRate(interestRate === "" ? "0" : interestRate)
                  }
                />
              </FormControl>
            </div>

            <div className=" p-2">
              <p
                style={{ fontSize: "14px", fontWeight: 600, color: "#311664" }}
                className="mb-1"
              >
                Loan Tenure (Years)
              </p>
              <Select
                fullWidth
                value={loanTenure}
                onChange={(e) => setLoanTenure(Number(e.target.value))}
                size="small"
              >
                {[...Array(30).keys()].map((year) => (
                  <MenuItem key={year + 1} value={year + 1}>
                    {year + 1} {year === 0 ? "Year" : "Years"}
                  </MenuItem>
                ))}
              </Select>
            </div>
            <div className="p-2">
              <Button
                variant="contained"
                fullWidth
                onClick={handleCalculate}
                style={{
                  marginTop: 20,
                  backgroundColor: "#311664",
                  color: "#ffffff",
                  textTransform: "none",
                }}
              >
                Calculate New EMI
              </Button>

              {newEMI && (
                <div
                  style={{ backgroundColor: "#f9fafb" }}
                  className="mt-3 rounded"
                >
                  <div className="p-4">
                    <h5
                      style={{
                        color: "#311664",
                        fontSize: "18px",
                        fontWeight: 700,
                        lineHeight: "28px",
                      }}
                    >
                      Result:
                    </h5>

                    <div className="d-flex flex-row justify-between w-100 mb-3">
                      <div className="w-100">
                        <p
                          style={{
                            color: "#311664",
                            fontSize: "16px",
                            lineHeight: "24px",
                            fontWeight: 500,
                            margin: "0px",
                          }}
                        >
                          Existing EMI:
                        </p>
                        <p
                          style={{
                            color: "rgb(58,134,139)",
                            fontSize: "20px",
                            lineHeight: "28px",
                            fontWeight: 500,
                            margin: "0px",
                          }}
                        >
                          {existingEMI}
                        </p>
                      </div>
                      <div className="w-100">
                        <p
                          style={{
                            color: "#311664",
                            fontSize: "16px",
                            lineHeight: "24px",
                            fontWeight: 500,
                            margin: "0px",
                          }}
                        >
                          New EMI:
                        </p>
                        <p
                          style={{
                            color: "rgb(58,134,139)",
                            fontSize: "20px",
                            lineHeight: "28px",
                            fontWeight: 500,
                            margin: "0px",
                          }}
                        >
                          {newEMI}
                        </p>
                      </div>
                    </div>
                    <div className="d-flex flex-row justify-between w-100">
                      <div className="w-100">
                        <p
                          style={{
                            color: "#311664",
                            fontSize: "16px",
                            lineHeight: "24px",
                            fontWeight: 500,
                            margin: "0px",
                          }}
                        >
                          Monthly Savings:
                        </p>
                        <p
                          style={{
                            color: "rgb(58,134,139)",
                            fontSize: "20px",
                            lineHeight: "28px",
                            fontWeight: 500,
                            margin: "0px",
                          }}
                        >
                          {monthlySavings}
                        </p>
                      </div>
                      <div className="w-100">
                        <p
                          style={{
                            color: "#311664",
                            fontSize: "16px",
                            lineHeight: "24px",
                            fontWeight: 500,
                            margin: "0px",
                          }}
                        >
                          Total Savings:
                        </p>
                        <p
                          style={{
                            color: "rgb(58,134,139)",
                            fontSize: "20px",
                            lineHeight: "28px",
                            fontWeight: 500,
                            margin: "0px",
                          }}
                        >
                          {totalSavings}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              )}

              <Button
                onClick={() => navigate("/credit-score")}
                variant="outlined"
                fullWidth
                style={{
                  marginTop: 20,
                  backgroundColor: "#59266D",
                  color: "#ffffff",
                  textTransform: "none",
                }}
              >
                Check Credit Score
              </Button>

              <Button
                variant="contained"
                fullWidth
                onClick={newEMI && handleShareClick}
                style={{
                  marginTop: 20,
                  backgroundColor: "#3A868B",
                  color: "#ffffff",
                  textTransform: "none",
                }}
              >
                <ShareOutlined
                  style={{ backgroundColor: "transparent", width: "20px" }}
                />
                &nbsp; Share Your Savings
              </Button>

              {/* Social Media Popover */}
              <Popover
                id={id}
                open={open}
                anchorEl={anchorEl}
                onClose={handleClose}
                anchorOrigin={{
                  vertical: "bottom",
                  horizontal: "center",
                }}
                transformOrigin={{
                  vertical: "top",
                  horizontal: "center",
                }}
              >
                <List>
                  <ListItem button onClick={handleWhatsAppShare}>
                    <ListItemIcon>
                      <WhatsApp style={{ color: "#25D366" }} />
                    </ListItemIcon>
                    <ListItemText
                      sx={{ color: "#1f1f1f" }}
                      primary="WhatsApp"
                    />
                  </ListItem>
                  <ListItem
                    button
                    onClick={() => {
                      const mailtoUrl = `mailto:?subject=I've saved on my EMI!&body=${encodeURIComponent(
                        shareMessage
                      )}`;
                      window.location.href = mailtoUrl;
                    }}
                  >
                    <ListItemIcon>
                      <Email style={{ color: "#D44638" }} />
                    </ListItemIcon>
                    <ListItemText sx={{ color: "#1f1f1f" }} primary="Email" />
                  </ListItem>
                </List>
              </Popover>
            </div>
          </CardContent>
        </Card>
      </div>
      <div className="emi_repo_contents_sectionTwo pt-0">
        <div className="emi_repo_contents  d-flex flex-column flex-md-row align-items-start gap-3  gap-lg-4 gap-xl-5 ">
          <section className=" repo_content_container pb-0 ">
            <StepOne />
          </section>

          <aside id="repo_side_bar__container" className="pb-4">
            <div className={`side_bar `}>
              <SideBar />
            </div>
          </aside>
        </div>
        <section className="">
          <MoreLikeThis />
        </section>
      </div>
    </div>
  );
};

export default NewEmiCalculator;
